import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/gfs-shift`)
  return data.data
}

export const useGFPShifts = () => {
  const { data, ...props } = useQuery(
    queryKeys.GFP_SHIFTS,
    () => getData(),
  )
  return { data, ...props }
}
